(() => {
  'use strict';
  document.querySelectorAll('[data-cbm-end-add]').forEach((button) => {
    if (button.dataset.cbmEndBound) return;
    const form = button.form;
    if (!form) return;
    const primary = form.querySelector('button[type="submit"]');
    if (!primary || primary === button) return;
    button.dataset.cbmEndBound = 'true';
    const update = () => {
      button.disabled = primary.disabled || form.getAttribute('aria-busy') === 'true';
      button.setAttribute('aria-busy', form.getAttribute('aria-busy') === 'true' ? 'true' : 'false');
    };
    update();
    new MutationObserver(update).observe(primary, { attributes:true, attributeFilter:['disabled','aria-disabled'] });
    new MutationObserver(update).observe(form, { attributes:true, attributeFilter:['aria-busy'] });
  });
})();
